import React from 'react'
import './index.css'

const DotLoader = () => (
   <div className='dots'>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
   </div>
)

export default DotLoader
